import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getUser } from "../../../../reducers";

import ActivityFormDialog from "./ActivityFormDialog";

function ActivityFormContainer({ formTitle, submitLabel = "Save", onSave, onClose, data = {}, ...props }) {
    const [title, setTitle] = useState(data.title || "");
    const [description, setDescription] = useState(data.description || "");
    const [type, setType] = useState(data.type || "");
    const [dateStart, setDateStart] = useState(data.dateStart || "");
    const [dateEnd, setDateEnd] = useState(data.dateEnd || "");
    const [duration, setDuration] = useState(data.duration?.total || "");
    const [reviewNA, setReviewNA] = useState(false);
    const [score, setScore] = useState(data?.score || { value: 0, unit: "points" });
    const [categories, setCategories] = useState(data?.categories || []);

    const [openCategoryDialog, setOpenCategoryDialog] = useState(false);

    const user = useSelector(getUser);

    const handleSubmit = () => {
        const params = {
            ...data,
            title,
            description,
            dateStart,
            dateEnd,
            score,
            categories,
            worker: { uuid: user.uuid },
            type,
            duration: !duration ? null : { total: duration, unit: "minutes" },
            review: data?.review || { status: reviewNA ? "n/a" : "deferred" },
        };
        onSave(params);
        onClose();
    };

    return (
        <ActivityFormDialog
            formTitle={formTitle}
            title={title}
            setTitle={setTitle}
            description={description}
            setDescription={setDescription}
            type={type}
            setType={setType}
            dateStart={dateStart}
            setDateStart={setDateStart}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
            duration={duration}
            setDuration={setDuration}
            reviewNA={reviewNA}
            setReviewNA={setReviewNA}
            score={score}
            setScore={setScore}
            categories={categories}
            setCategories={setCategories}
            onClose={onClose}
            onSubmit={handleSubmit}
            submitLabel={submitLabel}
            openCategoryDialog={openCategoryDialog}
            setOpenCategoryDialog={setOpenCategoryDialog}
            isEdit={!!data}
            {...props}
        />
    );
}

export default ActivityFormContainer;
